import { render } from "./AttrTab.vue?vue&type=template&id=fe2ab7c6"
import script from "./AttrTab.vue?vue&type=script&lang=js"
export * from "./AttrTab.vue?vue&type=script&lang=js"

import "./AttrTab.vue?vue&type=style&index=0&id=fe2ab7c6&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fe2ab7c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fe2ab7c6', __exports__)) {
    api.reload('fe2ab7c6', __exports__)
  }
  
  module.hot.accept("./AttrTab.vue?vue&type=template&id=fe2ab7c6", () => {
    api.rerender('fe2ab7c6', render)
  })

}


export default __exports__